import { useCallback, useMemo } from "react";

import useFileImportStore from "../../../stores/fileImportStore";

const DEFAULT_VALIDATION_STATE = { done: false, isValid: null };

function checkHeaders(importedHeaders) {
  let isValid = true;
  const requiredHeaders = ["Item", "PartNumber", "HTS", "Desc", "Qty", "Units", "TransactionValue", "COO", "Originating", "UnitCost", "Category", "NetCost", "TotalCost"];
  if (importedHeaders.length !== requiredHeaders.length) {
    isValid = false;
  }
  importedHeaders.forEach((header) => {
    if (requiredHeaders.indexOf(header) === -1) {
      isValid = false;
    }
  });
  return isValid;
}

export default function useHeaderConfirmationModal() {
  const parsedHeaders = useFileImportStore((s) => s.headers);

  const handleConfirmHeaders = useCallback(
    (_, { setSubmitting }) => {
      setSubmitting(true);
      useFileImportStore.getState().setHeaderValidation(DEFAULT_VALIDATION_STATE);
      const headersValid = checkHeaders(parsedHeaders);
      if (headersValid) {
        useFileImportStore.getState().setHeaders(parsedHeaders);
        useFileImportStore.getState().setHeaderValidation({ done: true, isValid: true });
        useFileImportStore.getState().setShowHeaderConfirmationModal(false);
      } else {
        useFileImportStore.getState().setHeaderValidation({ done: true, isValid: false });
      }
      setSubmitting(false);
    },
    [parsedHeaders],
  );

  return useMemo(() => ({ handleConfirmHeaders }), [handleConfirmHeaders]);
}
